import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { X } from 'lucide-react';
import { updateAgentPrompt } from '../../slice/agentWidgetsSlice';

const WidgetPromptEditor = ({
  taskId,
  catalogItem,
  onClose,
  aispaceColor = '#8B5CF6',
}) => {
  const dispatch = useDispatch();
  const prompts = useSelector((s) => s.agentWidgets.promptsByTask[taskId]) || {};
  const initial = prompts[catalogItem.key] ?? catalogItem.default_prompt ?? '';
  const [text, setText] = useState(initial);
  const [saving, setSaving] = useState(false);

  useEffect(() => setText(initial), [initial]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await dispatch(updateAgentPrompt({
        taskId, widgetKey: catalogItem.key, promptText: text,
      })).unwrap();
      onClose?.();
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-black/30" onClick={onClose}>
      <div
        className="bg-white rounded-xl shadow-xl w-[600px] max-w-[92vw] max-h-[80vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#E5E7EB]">
          <h3 className="text-[16px] font-semibold text-[#212121]">
            Prompt: {catalogItem.label}
          </h3>
          <button onClick={onClose} className="p-1 rounded hover:bg-[#F3F4F6] text-[#6B7280]">
            <X size={18} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-4">
          <p className="text-[13px] text-[#6B7280] mb-3">{catalogItem.description}</p>
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            className="w-full min-h-[240px] p-3 text-[13px] border border-[#E5E7EB] rounded-lg font-mono text-[#212121] focus:outline-none focus:ring-2"
            style={{ outlineColor: aispaceColor }}
            placeholder="Prompt text..."
          />
          <p className="text-[11px] text-[#9CA3AF] mt-2">
            Tipp: Verwende <code>{'{{TEXT}}'}</code> als Platzhalter für den Dokumentinhalt.
          </p>
        </div>
        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-[#E5E7EB]">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-[#E5E7EB] rounded-lg text-[14px] text-[#212121] hover:bg-[#F9FAFB]"
          >
            Abbrechen
          </button>
          <button
            onClick={handleSave}
            disabled={saving}
            className="px-4 py-2 text-white rounded-lg text-[14px] font-medium hover:opacity-90 disabled:opacity-50"
            style={{ backgroundColor: aispaceColor }}
          >
            {saving ? 'Speichern…' : 'Speichern'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WidgetPromptEditor;
